import { inject } from '@angular/core';
import { CanActivateFn, NavigationExtras, Router } from '@angular/router';
import { AuthService } from 'projects/shared/src/lib/auth/auth/data-access/auth.service';

export const isAuthenticatedGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  await authService.ensureUserLoaded();
  var subId = route.queryParams?.['subscription_id'] ?? '';
  const regex =
    /^sub_[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

  const cleanedSubId = regex.test(subId) ? subId : '';

  const queryParams: NavigationExtras | undefined = cleanedSubId
    ? {
        queryParams: { subscription_id: cleanedSubId },
        queryParamsHandling: 'merge',
      }
    : {};

  if (authService.user() && authService.isUserSet$.getValue()) {
    if (route.url[0].path.includes('selector')) {
      return true;
    }
    if (!cleanedSubId) {
      router.navigate(['selector'], queryParams);
      return false;
    }
    return true;
  }

  router.navigate(['login'], queryParams);
  return false;
};
